<page-layout>
  <div class="clouds-background">
    <div class="info-circle">
      <p>🌈</p>
      <h1>You've successfully verified your email!</h1>
    </div>
  </div>
</page-layout>
